import type { ReactNode } from "react";

interface AdminPageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  actions?: ReactNode;
}

export default function AdminPageHeader({ title, subtitle, icon, actions }: AdminPageHeaderProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="flex items-start gap-3">
        {icon && (
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
            <i className={`${icon} text-xl`}></i>
          </span>
        )}
        <div>
          <h1 className="font-heading text-2xl font-extrabold text-foreground-950">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-foreground-600">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}